import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import {
  selectFirestopImagesToAdd,
  selectFirestopItemsToCreate,
  selectSelectedFirestopListId,
} from '../selectors/firestop-documentation.selectors';
import { postCreateNewFirestops } from '../services/post-create-new-firestops.service';
import { closeAddNewFirestopsDialog } from '../actions/firestop-documentation.actions';

export const createNewFirestops = createAsyncThunk(
  'firestopDocumentation/createNewFirestops',
  async (_, { getState, dispatch }) => {
    const selectedProjectId = selectSelectedProjectId(getState());
    const selectedFirestopListId = selectSelectedFirestopListId(getState());
    const firestopItemsToCreate = selectFirestopItemsToCreate(getState());

    const firestopImagesToAdd = selectFirestopImagesToAdd(getState());

    const createdListData = await postCreateNewFirestops(
      selectedProjectId,
      selectedFirestopListId,
      Object.values(firestopItemsToCreate),
      firestopImagesToAdd
    );

    dispatch(closeAddNewFirestopsDialog());

    return createdListData;
  }
);
